import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RomeLibraryModule } from '../lib/rome-library.module';
import { RomeKendoModule } from '../rome-kendo/rome-kendo.module';
import { AddressComponent } from './address/address.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { BaseCollectionComponent } from './base-collection.component';
import { CheckboxListComponent } from './checkbox-list/checkbox-list.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { DropDownComponent } from './drop-down/drop-down.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { NumericInputComponent } from './numeric-input/numeric-input.component';
import { PostalAddressFinderComponent } from './postal-address-finder/postal-address-finder.component';
import { RadioButtonGroupComponent } from './radio-button-group/radio-button-group.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { TextInputComponent } from './text-input/text-input.component';
import { TextareaInputComponent } from './textarea-input/textarea-input.component';
import { TimePickerComponent } from './time-picker/time-picker.component';

const COMPONENTS = [
  BaseCollectionComponent,
  TextInputComponent,
  DropDownComponent,
  CheckboxComponent,
  TextareaInputComponent,
  NumericInputComponent,
  CheckboxListComponent,
  RadioButtonComponent,
  RadioButtonGroupComponent,
  DatePickerComponent,
  DateTimePickerComponent,
  MultiSelectComponent,
  FileUploadComponent,
  AutocompleteComponent,
  PostalAddressFinderComponent,
  AddressComponent,
  TimePickerComponent
];

@NgModule({
  declarations: COMPONENTS,
  exports: COMPONENTS,
  imports: [CommonModule, RomeLibraryModule, RomeKendoModule, FormsModule]
})
export class CommonControlsModule {}
